import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, UserPlus, AlertCircle } from 'lucide-react';

const RegisterPage = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(email, password, name);
      navigate('/health');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a1f13] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <a href="https://healthchoices.health" target="_blank" rel="noopener noreferrer">
            <img src="https://healthchoices.health/wp-content/uploads/2025/10/logo-1-296x86.png" alt="HealthChoices" className="h-14 mx-auto mb-4 brightness-0 invert" />
          </a>
          <h1 className="text-2xl font-bold text-white">Create Your Account</h1>
          <p className="text-gray-400 mt-1">Start your health tracking journey</p>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          {error && (
            <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-xl mb-6 text-sm text-red-700" data-testid="register-error">
              <AlertCircle className="w-4 h-4 flex-shrink-0" /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label className="text-sm font-medium text-gray-700">Full Name</Label>
              <Input type="text" value={name} onChange={e => setName(e.target.value)} required
                placeholder="Your full name" className="mt-1" data-testid="register-name" />
            </div>
            <div>
              <Label className="text-sm font-medium text-gray-700">Email</Label>
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                placeholder="you@example.com" className="mt-1" data-testid="register-email" />
            </div>
            <div>
              <Label className="text-sm font-medium text-gray-700">Password</Label>
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={6}
                placeholder="Min 6 characters" className="mt-1" data-testid="register-password" />
            </div>

            <Button type="submit" disabled={loading} className="w-full bg-[#166534] hover:bg-[#14532d] text-white py-5 rounded-xl" data-testid="register-submit">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><UserPlus className="w-4 h-4 mr-2" /> Create Account</>}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-500">
            Already have an account?{' '}
            <Link to="/login" className="text-[#166534] font-medium hover:underline" data-testid="go-to-login">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
